/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { UserInfoEntity } from "../interface/libraryGallery.interface";
import { getSessionStorageItem } from "../service/storage-service";
import { JB_GLASS_USER_INFO } from "../utils/constants";
import { IsNullOrUndefined, IsStringNullEmptyOrUndefined } from "../utils/nullCheck";

function UseDisableRightClick() {
    const location = useLocation();

    useEffect(() => {
        const handleRightClick = (event: any) => {
            console.log('Right-click disabled!');

            let userInfo: UserInfoEntity | null = null;
            const userStr: string | null = getSessionStorageItem(JB_GLASS_USER_INFO)

            if (userStr && !IsStringNullEmptyOrUndefined(userStr)) {
                userInfo = JSON.parse(userStr);
            }

            if (IsNullOrUndefined(userInfo) &&
                (
                    (event.target.tagName === 'IMG')
                    ||
                    (location.pathname && location.pathname.startsWith('/library'))
                )
            ) {
                event.preventDefault(); // Prevent right-click on images
            }
        };

        // Attach the event listener on component mount
        document.addEventListener('contextmenu', handleRightClick);

        // Clean up event listener on component unmount
        return () => {
            document.removeEventListener('contextmenu', handleRightClick);
        };
    }, []);
}

export default UseDisableRightClick;